import { Dayjs } from 'dayjs'
import { CoordinateType } from '@/api/types/general/GeneralType'
import WeatherServiceInterface from '@/utilities/weather/services/interfaces/WeatherServiceInterface'
import AbstractWeatherService from '@/utilities/weather/services/abstracts/AbstractWeatherService'
import { WeatherType } from '@/utilities/weather/types/WeatherType'
import Guard from '@/utilities/weather/guards/Guard'

export default class WeatherService implements WeatherServiceInterface {
  private readonly services: AbstractWeatherService[]

  constructor(...services: AbstractWeatherService[]) {
    this.services = services
  }

  async getInfo(coordinate: CoordinateType, date: Dayjs): Promise<WeatherType> {
    for (const service of this.services) {
      if (Guard.isValidate(service) && !service.isValid(date)) {
        continue
      }

      try {
        return await service.getInfo(coordinate, date)
      } catch (err) {
        console.warn(`Service ${service.constructor.name} is not available`)
      }
    }

    throw new Error('No any weather service are available')
  }
}
